<template>
    <div id="logworktime">
        <HrrBreadcrumb PMname="其他功能" CMname="媒体工作时长日志" />
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item label="站点名称：">
                        <el-select v-model="searchform.siteId" placeholder="请选择" filterable>
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in siteidData" :key="item.SiteId" :label="item.SiteName" :value="item.SiteId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="keyword" placeholder="关键字">
                            <el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                                <el-option label="媒体编号" value="lightBoxCode"></el-option>
                                <el-option label="设备编号" value="deviceNickCode"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="时间段：">
                        <el-date-picker v-model="searchform.startPostTime" placeholder="开始时间" value-format="yyyy-MM-dd" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="至">
                        <el-date-picker v-model="searchform.endPostTime" placeholder="结束时间" value-format="yyyy-MM-dd" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态：" prop="devStatus" v-if="false">
                        <el-select v-model="searchform.devStatus" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="发送" :value="1"></el-option>
                            <el-option label="未发送" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onExport">导出Excel</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="Opentable" @cell-click="cellclick" @selection-change="selectionchange" border stripe style="width: 100%" v-loading="loading">
                    <el-table-column prop="siteName" label="站点" width="160" fixed="left">
                    </el-table-column>
                    <el-table-column prop="lightBoxCode" label="媒体编号" width="140" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceNickCode" label="设备编号" width="140" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceCode" label="自动设备编号" width="140" fixed="left" v-if="isHadFun('deviceCode')">
                    </el-table-column>
                    <el-table-column prop="postTime" label="接收日期" width="160" fixed="left">
                    </el-table-column>
                    <el-table-column prop="theoryWorkTime" label="理论工作时长" width="160">
                    </el-table-column>
                    <el-table-column prop="workTime" label="工作时长" width="160">
                    </el-table-column>
                    <el-table-column prop="unworkTime" label="不工作时长" width="180">
                    </el-table-column>
                    <el-table-column label="异常时长">
                        <el-table-column prop="electricTime" label="电流异常" width="120">
                        </el-table-column>
                        <el-table-column prop="offlineTime" label="离线异常" width="120">
                        </el-table-column>
                    </el-table-column>
                    <el-table-column prop="errorContent" label="异常描述">
                        <template slot-scope="scope">
                            <el-popover placement="left" width="500" trigger="click" v-if="scope.row.ErrorArr.length>0">
                                <el-scrollbar class="infinite-list">
                                    <el-card class="el-card-dashed wk-el-card" v-for="d in scope.row.ErrorArr ">
                                        <el-row>
                                            <el-col>{{d}}</el-col>
                                        </el-row>
                                    </el-card>
                                </el-scrollbar>
                                <el-button slot="reference">查看</el-button>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
    </div>
</template>
<script>
export default {
    name: 'log_worktime',
    data() {
        return {
            searchform: {
                pageNum: 1,
                pageSize: 10,
                deviceNickCode: "",
                lightBoxCode: "",
                startPostTime: null,
                endPostTime: null,
            },
            tableData: [],
            siteidData: [],
            total: 0,
            loading: true,
            selectionRows: [],
            selectfield: "deviceNickCode",
            keyword: "",
        }
    },
    methods: {
        onSubmit() {
            this.searchform.deviceNickCode = "";
            this.searchform.lightBoxCode = "";
            this.searchform.pageNum = 1;
            this.searchform[this.selectfield] = this.keyword.trim();
            this.initData();
        },
        handleSizeChange(val) {
            this.searchform.pageSize = val;
            this.initData();
        },
        handleCurrentChange(val) {
            this.searchform.pageNum = val;
            this.initData();
        },
        onExport() {
            this.$confirm("确定要导出Excel数据么？", { type: "warning" })
                .then(() => {
                    var ExportURL = this.$api.Log.ExporWorkTime;
                    ExportURL = this.$hrraxios.defaults.baseURL + ExportURL;
                    var params = this.$Qs.stringify(this.searchform, { indices: false });
                    window.open(ExportURL + "?" + params);
                });

        },
        cellclick(row, column, cell, event) {
            this.$refs.Opentable.toggleRowSelection(row);
        },
        selectionchange(selection) {
            this.selectionRows = selection;
        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            this.$hrraxios.get(this.$api.Log.WorkTime, { params: this.searchform })
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.tableData = data.Data.List;
                        Vuethis.total = data.Data.Total;
                        Vuethis.tableData.forEach((element, index) => {
                            element.ErrorArr = [];
                            if (element.errorContent != '' && element.errorContent != null) {
                                element.ErrorArr = element.errorContent.split('；');
                                element.ErrorArr.length-=1;
                            }
                        });
                    } else {
                        Vuethis.$message.error(data.Data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        },
        initParamsData() {
            var Vuethis = this;
            var now = new Date();
            var start_now = now.setDate(now.getDate() - 2);
            start_now = new Date(start_now);
            start_now = start_now.toLocaleDateString().split('/').join('-');
            var end_now = now.setDate(now.getDate() + 1);
            end_now = new Date(end_now);
            end_now = end_now.toLocaleDateString().split('/').join('-');
            this.searchform.startPostTime = start_now;
            this.searchform.endPostTime = end_now;
            //站点
            this.$hrraxios.get(this.$api.site.downlist)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.siteidData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        to.meta.row = from.meta.row;
        next();
    },
    created() {
        this.$common.getFunListByMCode(this, "WorkTimeLog", () => {
            this.initData();
            this.initParamsData();
        });
    }
};
</script>
<style>
.input-with-select {
    width: 110px;
}

.educard label {
    color: #99a9bf;
}

.educard {
    margin-bottom: 10px;
}

.utable .el-button,
.utable .el-button+.el-button {
    margin-right: 10px;
    margin-left: 0;
}
.wk-el-card{
    margin-bottom: 6px;
}
</style>